.headingSection {
    background-color: #f9f9f9;
    text-align: center;
}

.mainContentSectionOuter {
    background-color: white;
}

.mainContentSectionOuter {
    background-color: white;
}

.contentSection {
    width: 100%;
    max-width: 1100px;
}

.secondaryContentSectionOuter {
    background-color: #e7f4f5;
}


.heading {
    font-size: 32px;
    color: #3caeb0;
    font-weight: bold;
    line-height: 1.1em;
}

.subsectionHeading {
    color: #3caeb0;
    font-size: 24px;
    line-height: 1.1em;
    font-weight: 700;
}

.form {
    padding: 48px 0;
}

.employeeName {
    color: #3caeb0;
    font-size: 20px;
    font-weight: bold;
}

.employeeTitle {
    color: #3caeb0;
    font-size: 19px;
    text-transform: uppercase;
    font-weight: bold;
    line-height: 1.1em;
}

@media (min-width: 768px) {
    .employeeName {
        font-size: 24px;
    }

    .employeeTitle {
        font-size: 19px;
    }

    .heading {
        font-size: 50px;
    }

    .headingDarkBg {
        font-size: 50px;
    }

    .form {
        padding: 96px 20px;
    }

    .subsectionHeading {
        font-size: 35px;
    }

    .subsectionHeadingDarkBg {
        font-size: 35px;
    }

    .heading3 {
        font-size: 24px;
    }

    .heading3DarkBg {
        font-size: 24px;
    }

    .meetTheDoctorContainer {
        /*display: grid;*/
        /*grid-template-columns: 1fr 1fr;*/
        /*grid-template-areas:*/
        /*    "drGarciaImage meetDrGarcia"*/
        /*    "educationAndExperience communityInvolvement"*/
        /*    "smilingInMiami professionalAffiliations";*/
        gap: 42px;
        padding-right: 90px;
        padding-left: 90px;
    }

    .meetDrGarcia {
        grid-area: meetDrGarcia;
        flex-basis: 46%;
    }

    .drGarciaImage {
        grid-area: drGarciaImage;
        order: 0;
        flex-basis: 46%;
    }

    .educationAndExperience {
        grid-area: educationAndExperience;
        flex-basis: 46%;
    }

    .communityInvolvement {
        grid-area: communityInvolvement;
        flex-basis: 46%;
    }

    .smilingInMiami {
        grid-area: smilingInMiami;
        flex-basis: 46%;
    }

    .professionalAffiliations {
        grid-area: professionalAffiliations;
        flex-basis: 46%;
        margin-top: -90px;
    }


}
